module.exports = __webpack_public_path__ + "img/34_54.2d754983.png";